import React from 'react';
import './RegisterModal.css'; // You will create this CSS file to match the design
import moment from "moment-timezone";
import { Spinner } from "@chakra-ui/react";

// The slot's date in the office's timezone, the one its time is written in (the api formats
// `time` there). In the browser's own zone a late slot read as the next day: "October 7 at
// 5:00pm" for a 5pm Pacific slot seen from a browser on UTC.
export const slotDate = (slot, zone) =>
  (zone && moment.tz.zone(zone) ? moment.tz(slot.date, zone) : moment(slot.date)).format('LL');

const RegisterModal = ({ onClose, onRegister, selectedTimeSlot, isSubmitting, zone }) => {
  const handleFormSubmit = (event) => {
    event.preventDefault();
    onRegister();
  };

  return (
    <div className="modal-backdrop">
      <div className="register-modal">
        <div className="modal-header">
          <h2>{selectedTimeSlot.service_name} Appointment</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-content">
          <p>Your appointment is
            with {selectedTimeSlot.title} {selectedTimeSlot.name} on {slotDate(selectedTimeSlot, zone)} at {selectedTimeSlot.time}.</p>
          <form onSubmit={handleFormSubmit}>
            <button disabled={isSubmitting} type="submit" className="confirm-button"> {isSubmitting ?
              <Spinner size="sm"/> : "Confirm"}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
